module.exports = __webpack_public_path__ + "static/img/banner.9a37971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tech/banner.png
// module id = 6hOt
// module chunks = 11